module.exports = __webpack_public_path__ + "img/initialRegistration.967cfe54.svg";